import { toTimestamp } from '../utils/addWebSocketToReplication'
import { toISOString, toISOStringOrNull } from '../utils/pushSafetyUtils'
import { createReplication } from './createReplication'
import type { CustomFieldTabCollection } from '../index'

export const setupCustomFieldTabReplication = (
  collection: CustomFieldTabCollection,
  envId: string,
) =>
  createReplication({
    entityName: 'customfieldtabs',
    displayName: 'CustomFieldTab',
    collection,
    envId,
    apiEntityName: 'custom-field-tabs',
    mapFromServer: (doc) => ({
      id: doc.id,
      envId: doc.envId,
      name: doc.name,
      icon: doc.icon ?? '',
      renderMode: (doc.renderMode === 'inline' ? 'inline' : 'tab') as 'inline' | 'tab',
      isSystem: doc.isSystem || false,
      sortOrder: doc.sortOrder ?? null,
      workItemTypeIds: doc.workItemTypeIds || [],
      projectIds: doc.projectIds || [],
      isDeleted: doc.isDeleted || false,
      createdOn: toTimestamp(doc.createdOn) ?? new Date(doc.createdOn).getTime(),
      createdBy: doc.createdBy,
      updatedOn: toTimestamp(doc.updatedOn) ?? new Date(doc.updatedOn).getTime(),
      updatedBy: doc.updatedBy,
      deletedOn: doc.deletedOn ? (toTimestamp(doc.deletedOn) ?? new Date(doc.deletedOn).getTime()) : null,
      deletedBy: doc.deletedBy,
    }),
    mapToServer: (state, envId) => ({
      id: state.id,
      envId,
      name: state.name,
      icon: state.icon,
      renderMode: state.renderMode,
      isSystem: state.isSystem,
      sortOrder: state.sortOrder,
      workItemTypeIds: state.workItemTypeIds,
      projectIds: state.projectIds,
      isDeleted: state.isDeleted,
      createdOn: toISOString(state.createdOn),
      createdBy: state.createdBy,
      updatedOn: toISOString(state.updatedOn),
      updatedBy: state.updatedBy,
      deletedOn: toISOStringOrNull(state.deletedOn),
      deletedBy: state.deletedBy,
    }),
  })
